<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>
      <span style="display:inline-block">Broker details </span><mat-spinner style="display:inline-block; margin-left:20px" *ngIf="!loaded" diameter="20" strokeWidth="3" mode="indeterminate"></mat-spinner>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Originator</mat-label>
          <input type="text" placeholder="Originator" matInput [formControl]="originator" [matAutocomplete]="brokerAuto" (keyup.enter)="chooseFirstOption()">
          <mat-autocomplete [autoActiveFirstOption]="true" #brokerAuto="matAutocomplete" [displayWith]="displayName">
            <mat-option *ngFor="let option of filteredOriginators | async" [value]="option">
              {{option.name}}
            </mat-option>
          </mat-autocomplete>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'originator'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Broker</mat-label>
          <input type="text" placeholder="Broker" matInput [formControl]="broker" [matAutocomplete]="auto" (keyup.enter)="chooseFirstOption()">
          <mat-autocomplete [autoActiveFirstOption]="true" #auto="matAutocomplete" [displayWith]="displayName">
            <mat-option *ngFor="let option of filteredBrokers | async" [value]="option">
              {{option.name}}
            </mat-option>
          </mat-autocomplete>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'broker'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Contact</mat-label>
          <input [hidden]="contacts && contacts.length > 1" type="text" *ngIf="contacts && contacts.length === 1" placeholder="Contact" matInput [value]="contacts[0].name" readonly/>
          <mat-select panelClass="full-width" [hidden]="contacts && contacts.length === 1" placeholder="Contact" formControlName="contact">
            <mat-option *ngFor="let contact of contacts" [value]="contact">
              {{ contact.name }}
            </mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'contact'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
